<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import Multiselect from 'vue-multiselect';
import Swal from 'sweetalert2'
import moment from "moment";
import draggable from 'vuedraggable';
import * as XLSX from "xlsx";
/**
 * Starter component
 */
export default {
    components: { Layout, PageHeader, Multiselect, draggable },
    data() {
        const maxFileSizeMb = 80;
        const maxTotalSizeMb = 190;

        return {
            title: "Asociar evento",
            maxFileSizeMb,
            maxTotalSizeMb,
            maxFileSizeBytes: maxFileSizeMb * 1024 * 1024,
            maxTotalSizeBytes: maxTotalSizeMb * 1024 * 1024,
            items: [
                {
                text: "Digitalizar",
                href: "/"
                },
                {
                text: "Asociar evento",
                active: true
                }
            ],
            usuarios:[],
            laborantes:[],
            eventos:[],
            lab:{},
            currentPage: 1,
            perPage: 10,
            pageOptions: [10, 25, 50, 100],
            filtro: '',
            asociaciones:[],
            ver:false,
            imagenesSeleccionadas: [],
            archivosDuplicadosAviso: [],
            imagenesPreview: [],
            datosLabEvento:{},
            tipoFormulario: 'v3',
            selected: '',
            isLoading: false,
            isInitialLoading: false,
            loadingOverlayMode: '',
            digitalizarDisabled: false,
            syncingAsociaciones: false,
            tipos:[],
            finalizandoIds: {},
            mostrarFinalizados: false,
            sortKey: null,
            sortOrder: 'asc',
            filtroSede: '',
            filtroCoordinador: '',
            filtroLaborante: '',
            filtrosPredeterminadosAplicados: false,
            // Sección concluidos
            pagosDigitalizacion: [],
            filtroConcluidos: '',
            currentPageConcluidos: 1,
            perPageConcluidos: 25,
            loadingConcluidos: false,
            loadingFinalizadas: false,
            reprocesandoTodos: false,
            soloListosParaFinalizar: false,
            // Transferir fichas pendientes
            transferirItem: null,
            transferirDestino: null,
            isTransferring: false,
            // IDs (asociaciones) actualmente en refresco para mostrar overlay por fila
            refrescandoIds: {},
        };
    },
    watch: {
        filtro() {
            this.currentPage = 1;
        },
        filtroSede() {
            this.currentPage = 1;
        },
        perPage() {
            this.currentPage = 1;
        },
        filteredData(newValue) {
            const totalPages = Math.max(1, Math.ceil(newValue.length / this.perPage));
            if (this.currentPage > totalPages) {
                this.currentPage = totalPages;
            }
        },
        soloListosParaFinalizar() {
            this.currentPage = 1;
        },
    },
    computed:{
        rows() {
            return this.filteredData.length;
        },
        totalFilasRefrescando() {
            return Object.keys(this.refrescandoIds || {}).length;
        },
        sedesDisponibles() {
            const sedes = new Set();
            this.asociaciones.forEach(item => {
                const sede = item.evento?.sede_asociada;
                if (sede) sedes.add(sede);
            });
            if (this.user && this.user.rol === 'Coordinador' && this.user.sede) {
                sedes.add(this.user.sede);
            }
            const sorted = Array.from(sedes).sort();
            return [{ value: '', text: 'Todas las sedes' }, ...sorted.map(s => ({ value: s, text: s }))];
        },
        coordinadoresDisponibles() {
            const set = new Set();
            this.asociaciones.forEach(item => {
                const c = this.obtenerNombreCoordinador(item.evento?.coordinador_evento, item.evento);
                if (c) set.add(c);
            });
            if (this.user && this.user.rol === 'Coordinador' && this.user.name) {
                set.add(this.user.name.toString().trim());
            }
            const sorted = Array.from(set).sort((a, b) => a.localeCompare(b, 'es', { sensitivity: 'base' }));
            return [{ value: '', text: 'Todos los coordinadores' }, ...sorted.map(c => ({ value: c, text: c }))];
        },
        laborantesDisponibles() {
            const map = new Map();
            this.asociaciones.forEach(item => {
                const id = item.laborante?.id;
                const nombre = (item.laborante?.name || '').toString().trim();
                if (id && nombre && !map.has(id)) map.set(id, nombre);
            });
            const sorted = Array.from(map.entries()).sort((a, b) => a[1].localeCompare(b[1], 'es', { sensitivity: 'base' }));
            return [{ value: '', text: 'Todos los laborantes' }, ...sorted.map(([id, nombre]) => ({ value: id, text: nombre }))];
        },
        filteredData() {
            const filtro = this.filtro.toLowerCase();
            let result = this.asociaciones.filter((item) => {
                if (!this.mostrarFinalizados && item.finalizada) return false;
                if (this.soloListosParaFinalizar && !(Boolean(item.puede_finalizar) && !item.finalizada)) return false;
                if (this.filtroSede && (item.evento?.sede_asociada || '') !== this.filtroSede) return false;
                const coordinadorNombre = this.obtenerNombreCoordinador(item.evento?.coordinador_evento, item.evento);
                if (this.filtroCoordinador && this.normalizarTexto(coordinadorNombre) !== this.normalizarTexto(this.filtroCoordinador)) return false;
                if (this.filtroLaborante && Number(item.laborante?.id) !== Number(this.filtroLaborante)) return false;
                const rut = (item.laborante?.rut || '').toString().toLowerCase();
                const name = (item.laborante?.name || '').toString().toLowerCase();
                const codigoEvento = (item.evento?.codigo || '').toString().toLowerCase();
                const rbdEvento = (item.evento?.rbd_colegio || '').toString().toLowerCase();
                const coordinador = (coordinadorNombre || '').toString().toLowerCase();
                const coordinadorRaw = (item.evento?.coordinador_evento || '').toString().toLowerCase();
                return (
                    rut.includes(filtro) ||
                    name.includes(filtro) ||
                    codigoEvento.includes(filtro) ||
                    rbdEvento.includes(filtro) ||
                    coordinador.includes(filtro) ||
                    coordinadorRaw.includes(filtro)
                );
            });
            if (this.sortKey) {
                const fieldMap = {
                    revisadas: 'fichas_revisadas',
                    descartadas: 'fichas_descartadas',
                    faltantes: 'fichas_faltantes',
                };
                const field = fieldMap[this.sortKey];
                result = result.slice().sort((a, b) => {
                    const av = Number(a[field] ?? 0);
                    const bv = Number(b[field] ?? 0);
                    return this.sortOrder === 'asc' ? av - bv : bv - av;
                });
            } else {
                result = result.slice().sort((a, b) => {
                    const ai = Number(a.id || 0);
                    const bi = Number(b.id || 0);
                    return bi - ai; // descendente
                });
            }
            return result;
        },
        paginatedData() {
            const start = (this.currentPage - 1) * this.perPage;
            const end = start + this.perPage;
            return this.filteredData.slice(start, end)
        },
        totalPages() {
            return Math.ceil(this.filteredData.length / this.perPage);
        },
        filteredConcluidos() {
            const f = this.filtroConcluidos.toLowerCase();
            if (!f) return this.pagosDigitalizacion;
            return this.pagosDigitalizacion.filter(item => {
                const coordinadorNombre = this.obtenerNombreCoordinador(item.evento?.coordinador_evento, item.evento);
                return (item.evento?.codigo || '').toLowerCase().includes(f)
                    || (item.evento?.rbd_colegio || '').toLowerCase().includes(f)
                    || (item.laborante?.name || '').toLowerCase().includes(f)
                    || (coordinadorNombre || '').toLowerCase().includes(f)
                    || (item.evento?.coordinador_evento || '').toLowerCase().includes(f)
                    || (item.evento?.colegio || '').toLowerCase().includes(f);
            });
        },
        paginatedConcluidos() {
            const start = (this.currentPageConcluidos - 1) * this.perPageConcluidos;
            return this.filteredConcluidos.slice(start, start + this.perPageConcluidos);
        },
        rowsConcluidos() {
            return this.filteredConcluidos.length;
        },
        canManageCleanupButtons() {
            if (!this.user) return false;
            const userId = parseInt(this.user.id);
            return [1, 6].includes(userId);
        },
        canViewCrmStats() {
            if (!this.user) return false;
            return parseInt(this.user.id) === 1;
        },
        canForceEliminar() {
            if (!this.user) return false;
            return parseInt(this.user.id) === 1;
        },
        canUseFormularioNuevo() {
            if (!this.user) return false;
            return this.user.rol !== 'Laborante';
        },
        canUseFormularioV3() {
            return Boolean(this.user);
        },
        formularioTipoOptions() {
            return [
                {
                    text: 'Digitalizador V3 (solo frontal)',
                    value: 'v3',
                    disabled: !this.canUseFormularioV3,
                },
                { text: 'Digitalizador V2 (desactivado)', value: 'v2', disabled: true },
                { text: 'Digitalizador V1 (desactivado)', value: 'v1', disabled: true },
            ];
        },
        canViewFinalizadosControls() {
            if (!this.user) return false;
            return this.user.rol !== 'Laborante';
        },
        canViewEventosConcluidos() {
            if (!this.user) return false;
            return this.user.rol !== 'Laborante';
        },
        canReenviarCrmButtons() {
            if (!this.user) return false;
            return parseInt(this.user.id) === 1;
        },
        canVerStats() {
            if (!this.user) return false;
            return ['Admin', 'Supervisor'].includes(this.user.rol);
        },
        statsPendientesRevision() {
            return this.asociaciones
                .filter(a => !a.finalizada)
                .reduce((sum, a) => sum + Number(a.fichas_faltantes ?? 0), 0);
        },
        statsAsocPendientes() {
            return this.asociaciones
                .filter(a => !a.finalizada && Number(a.fichas_totales ?? 0) > 0 && Number(a.porcentaje_avance ?? 0) < 100)
                .length;
        },
        statsAsocRevisadasSinFinalizar() {
            return this.asociaciones
                .filter(a => !a.finalizada && Number(a.porcentaje_avance ?? 0) >= 100 && Number(a.fichas_totales ?? 0) > 0)
                .length;
        },
        statsErroresCrm() {
            return this.asociaciones.reduce((sum, a) => sum + Number(a.crm_fallidos ?? 0), 0);
        },
        statsDescartes() {
            return this.asociaciones.reduce((sum, a) => sum + Number(a.fichas_descartadas ?? 0), 0);
        },
    },
    methods:{
        normalizarTexto(valor) {
            return (valor || '')
                .toString()
                .normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '')
                .trim()
                .toLowerCase();
        },
        normalizarRut(valor) {
            return (valor || '')
                .toString()
                .toUpperCase()
                .replace(/\./g, '')
                .replace(/\s+/g, '')
                .trim();
        },
        obtenerNombreCoordinador(coordinadorRaw, evento = null) {
            const raw = (coordinadorRaw || '').toString().trim();
            const usuarios = Array.isArray(this.usuarios) ? this.usuarios : [];
            const propietarioRaw = (evento && (evento.propietario || evento.propietario_colegio || evento.coordinador))
                ? (evento.propietario || evento.propietario_colegio || evento.coordinador).toString().trim()
                : '';

            if (!raw && !propietarioRaw && !evento) {
                return '';
            }

            const userId = Number(evento && evento.user_id ? evento.user_id : 0);
            if (userId) {
                const porId = usuarios.find((u) => Number(u.id) === userId);
                if (porId && porId.name) {
                    return porId.name.toString().trim();
                }
            }

            const rutNormalizado = this.normalizarRut(raw);
            if (rutNormalizado) {
                const porRut = usuarios.find((u) => this.normalizarRut(u.rut) === rutNormalizado);
                if (porRut && porRut.name) {
                    return porRut.name.toString().trim();
                }
            }

            const nombreNormalizado = this.normalizarTexto(raw);
            if (nombreNormalizado) {
                const porNombre = usuarios.find((u) => this.normalizarTexto(u.name) === nombreNormalizado);
                if (porNombre && porNombre.name) {
                    return porNombre.name.toString().trim();
                }
            }

            const propietarioNormalizado = this.normalizarTexto(propietarioRaw);
            if (propietarioNormalizado) {
                const porPropietario = usuarios.find((u) => this.normalizarTexto(u.name) === propietarioNormalizado);
                if (porPropietario && porPropietario.name) {
                    return porPropietario.name.toString().trim();
                }

                return propietarioRaw;
            }

            return raw;
        },
        asociar(){
            if (!this.lab.laborante || !this.lab.event) {
                Swal.fire({
                    icon: 'warning',
                    title: 'Campos requeridos',
                    text: 'Debes seleccionar un laborante y un evento.'
                });
                return;
            }
            this.isLoading = true;
            axios.post('/api/asociarLabEvento', {
                laborante_id: this.lab.laborante.id,
                laborante: this.lab.laborante,
                event_id: this.lab.event.id,
                event: this.lab.event
            })
            .then(async ({ data }) => {
                const creada = Boolean(data && data.created);
                Swal.fire({
                    icon: creada ? 'success' : 'info',
                    title: creada ? 'Asociación exitosa' : 'Asociación ya activa',
                    text: (data && data.message)
                        ? data.message
                        : (creada
                            ? 'El laborante fue asociado al evento correctamente.'
                            : 'Ya existe una asociación activa para este evento y laborante.')
                });
                this.ver = false;
                // limpiar selección
                this.lab = {};
                // refrescar la lista desde el servidor para mostrar la nueva asociación
                this.syncingAsociaciones = true;
                await this.refreshAsociados();
            })
            .catch(error => {
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'No se pudo asociar el laborante al evento.'
                });
                console.error(error);
            })
            .finally(() => {
                this.syncingAsociaciones = false;
                this.isLoading = false;
            });
        },
        labelselect_laborante ({ name }) {
            return `${name}`
        },
        nombreCortoConPuntos(nombreCompleto, maxPartes = 2) {
            const texto = (nombreCompleto || '').toString().trim().replace(/\s+/g, ' ');
            if (!texto) {
                return '-';
            }

            const partes = texto.split(' ');
            if (partes.length <= maxPartes) {
                return texto;
            }

            return `${partes.slice(0, maxPartes).join(' ')}...`;
        },
        textoAcotado(texto, maxChars = 26) {
            const valor = (texto || '').toString().trim();
            if (!valor) {
                return '-';
            }

            if (valor.length <= maxChars) {
                return valor;
            }

            return `${valor.slice(0, maxChars)}...`;
        },
        etiquetaTipoFormulario(tipo) {
            const t = (tipo || '').toString().toLowerCase();
            if (t === 'v3' || t === 'frontal' || t === 'frontal_only') return 'Digitalizador V3';
            if (t === 'v2' || t === 'nueva') return 'Digitalizador V2';
            return 'Digitalizador V1';
        },
        estiloTipoFormulario(tipo) {
            const t = (tipo || '').toString().toLowerCase();

            if (t === 'v3' || t === 'frontal' || t === 'frontal_only') {
                return {
                    display: 'inline-block',
                    padding: '2px 6px',
                    borderRadius: '999px',
                    fontSize: '0.68rem',
                    fontWeight: '600',
                    color: '#155724',
                    backgroundColor: '#d4edda',
                    border: '1px solid #c3e6cb',
                };
            }

            if (t === 'v2' || t === 'nueva') {
                return {
                    display: 'inline-block',
                    padding: '2px 6px',
                    borderRadius: '999px',
                    fontSize: '0.68rem',
                    fontWeight: '600',
                    color: '#0c5460',
                    backgroundColor: '#d1ecf1',
                    border: '1px solid #bee5eb',
                };
            }

            return {
                display: 'inline-block',
                padding: '2px 6px',
                borderRadius: '999px',
                fontSize: '0.68rem',
                fontWeight: '600',
                color: '#856404',
                backgroundColor: '#fff3cd',
                border: '1px solid #ffeeba',
            };
        },
        labelEvento(evento) {
            return `${evento.codigo} - ${evento.nombre_difusion}`;
        },
        ver_boton(){
            if(this.ver){
                this.ver = false;
            }else{
                this.ver = true;
            }
        },
        cancelar(){
            if(!this.ver){
                this.ver = true;
            }else{
                this.ver = false;
            }
        },
        modal_subir_imagenes(item){
            if (Boolean(item?.finalizada)) {
                Swal.fire({
                    icon: 'warning',
                    title: 'Asociación finalizada',
                    text: 'No se pueden subir fichas en una asociación finalizada.'
                });
                return;
            }
            console.log(item)
            this.datosLabEvento=item;
            this.tipoFormulario = 'v3';
            this.archivosDuplicadosAviso = [];
            this.$refs['modal-subir'].show();
        },
        totalArchivosSeleccionadosBytes() {
            return this.imagenesSeleccionadas.reduce((acc, actual) => {
                return acc + (actual?.file?.size || 0);
            }, 0);
        },
        claveArchivo(file) {
            return `${file.name}::${file.size}::${file.lastModified}`;
        },
        agregarImagenes(event) {
            const nuevosArchivos = Array.from(event.target.files);
            const clavesSeleccionadas = new Set(
                this.imagenesSeleccionadas.map(item => this.claveArchivo(item.file))
            );
            let totalReservado = this.totalArchivosSeleccionadosBytes();
            const duplicados = [];
            nuevosArchivos.forEach((file) => {
                // Validar tipo de archivo
                const tiposPermitidos = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif', 'application/pdf'];
                if (!tiposPermitidos.includes(file.type)) {
                    Swal.fire({
                        icon: 'warning',
                        title: 'Tipo de archivo no válido',
                        text: `El archivo ${file.name} no es una imagen o PDF válido.`
                    });
                    return;
                }

                if (file.size > this.maxFileSizeBytes) {
                    Swal.fire({
                        icon: 'warning',
                        title: 'Archivo demasiado grande',
                        text: `El archivo ${file.name} supera el límite de ${this.maxFileSizeMb} MB.`
                    });
                    return;
                }

                const clave = this.claveArchivo(file);
                const yaExiste = clavesSeleccionadas.has(clave);
                if (!yaExiste) {
                    if (totalReservado + file.size > this.maxTotalSizeBytes) {
                        Swal.fire({
                            icon: 'warning',
                            title: 'Límite total excedido',
                            text: `La suma de archivos no puede superar ${this.maxTotalSizeMb} MB por envío.`
                        });
                        return;
                    }
                    clavesSeleccionadas.add(clave);
                    totalReservado += file.size;

                    if (file.type === 'application/pdf') {
                        // Para PDFs, usar un ícono genérico como preview
                        this.imagenesSeleccionadas.push({
                            file,
                            preview: '/images/pdf-icon.png', // Necesitarás agregar este ícono
                            isPdf: true
                        });
                    } else {
                        // Para imágenes, crear preview normal
                        const imagenSeleccionada = {
                            file,
                            preview: '',
                            isPdf: false
                        };
                        this.imagenesSeleccionadas.push(imagenSeleccionada);
                        const lector = new FileReader();
                        lector.onload = (e) => {
                            this.$set(imagenSeleccionada, 'preview', e.target.result);
                        };
                        lector.readAsDataURL(file);
                    }
                } else {
                    duplicados.push(file.name);
                }
            });
            this.$refs.inputImagenes.value = '';
            if (duplicados.length > 0) {
                this.archivosDuplicadosAviso = [
                    ...new Set([...this.archivosDuplicadosAviso, ...duplicados])
                ];
            }
        },
        guardarImagenes(bvModalEvt) {
            if (this.isLoading) return;
            if (bvModalEvt) bvModalEvt.preventDefault();
            this.loadingOverlayMode = '';
            this.isLoading = true;
            if (this.imagenesSeleccionadas.length === 0) {
                Swal.fire({
                    icon: 'warning',
                    title: 'Sin archivos',
                    text: 'Debes seleccionar al menos una imagen o PDF.'
                });
                this.isLoading = false;
                return;
            }

            const totalSeleccionado = this.totalArchivosSeleccionadosBytes();
            if (totalSeleccionado > this.maxTotalSizeBytes) {
                Swal.fire({
                    icon: 'warning',
                    title: 'Límite total excedido',
                    text: `La suma de archivos no puede superar ${this.maxTotalSizeMb} MB por envío.`
                });
                this.isLoading = false;
                return;
            }

            const useFormularioV3 = this.tipoFormulario === 'v3';
            const useFormularioV2 = !useFormularioV3;
            this.loadingOverlayMode = useFormularioV2 ? 'ocr' : 'upload';

            const formData = new FormData();
            this.imagenesSeleccionadas.forEach((imgObj, i) => {
                formData.append(`imagenes[]`, imgObj.file);
            });
            formData.append('laborante_id', this.datosLabEvento.laborante_id);
            formData.append('evento_id', this.datosLabEvento.evento_id);
            formData.append('formulario_nuevo', useFormularioV2 ? '1' : '0');
            formData.append('formulario_tipo', useFormularioV3 ? 'v3' : 'v2');
            axios.post('/api/uploadImagesS3', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then(response => {
                const usedFormularioV2 = Boolean(response?.data?.used_formulario_v2);
                const usedFormularioTipo = String(response?.data?.used_formulario_tipo || this.tipoFormulario).toLowerCase();
                const totalUploaded = Number(response?.data?.total_uploaded || 0);
                const totalSkipped = Number(response?.data?.total_skipped || 0);
                const duplicateFiles = response?.data?.duplicate_files || [];
                this.archivosDuplicadosAviso = [...new Set(duplicateFiles)];
                let resultado = usedFormularioV2
                    ? `${totalUploaded} página(s) procesada(s) con OCR. Los datos se pre-completaron para revisión.`
                    : (usedFormularioTipo === 'v3'
                        ? `${totalUploaded} archivo(s)/pagina(s) procesado(s) en Digitalizador V3 (solo frontal).`
                        : `${totalUploaded} archivo(s) procesado(s) correctamente`);
                if (totalSkipped > 0) {
                    resultado += ` ${totalSkipped} archivo(s) duplicado(s) fueron omitidos.`;
                }
                Swal.fire({
                    icon: totalUploaded > 0 ? 'success' : 'info',
                    title: totalUploaded > 0 ? 'Carga completada' : 'Archivo duplicado',
                    text: resultado
                });
                this.imagenesSeleccionadas = [];
                if (totalUploaded > 0 && totalSkipped === 0) {
                    this.$refs['modal-subir'].hide();
                }
                // refrescar SOLO la fila afectada (mucho más rápido que recargar todas)
                const refreshRowId = this.datosLabEvento && this.datosLabEvento.id;
                this.marcarRefrescando(refreshRowId);
                this.syncingAsociaciones = true;
                Promise.resolve(this.refreshAsociadoById(refreshRowId)).finally(() => {
                    this.desmarcarRefrescando(refreshRowId);
                    this.syncingAsociaciones = false;
                });
                this.isLoading = false;
                this.loadingOverlayMode = '';
            }).catch(error => {
                console.log(error);
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'Hubo un problema al procesar los archivos'
                });
                this.isLoading = false;
                this.loadingOverlayMode = '';
            });
        },
        eliminarImagen(index) {
            this.imagenesSeleccionadas.splice(index, 1);
            // resetear input file nativo
            if (this.$refs.inputImagenes) {
                this.$refs.inputImagenes.value = '';
            }
        },
        href_digitalizar(item){
            if (Boolean(item?.finalizada)) {
                const alternativa = this.asociaciones.find((asociacion) => {
                    if (Number(asociacion?.evento_id) !== Number(item?.evento_id)) {
                        return false;
                    }

                    if (Boolean(asociacion?.finalizada)) {
                        return false;
                    }

                    const pendientes = Number(asociacion?.fichas_faltantes ?? this.fichasPendientes(asociacion));
                    return pendientes > 0;
                });

                if (alternativa) {
                    Swal.fire({
                        icon: 'info',
                        title: 'Asociación finalizada',
                        text: 'Esta asociación está finalizada. Te redirigimos a la asociación activa con fichas pendientes de este evento.',
                        timer: 2600,
                        showConfirmButton: false,
                    });
                    setTimeout(() => {
                        window.location.href = `/web/digitalizar/encuesta/${alternativa.evento_id}/${alternativa.laborante_id}?asociacion_id=${alternativa.id}`;
                    }, 700);
                    return;
                }

                Swal.fire({
                    icon: 'warning',
                    title: 'Asociación finalizada',
                    text: 'No se puede digitalizar porque esta asociación está finalizada.'
                });
                return;
            }
            window.location.href = `/web/digitalizar/encuesta/${item.evento_id}/${item.laborante_id}?asociacion_id=${item.id}`;
        },
        href_ver(item){
            window.location.href = `/web/digitalizar/ver/${item.evento_id}/${item.laborante_id}?asociacion_id=${item.id}`;
        },
        marcarRefrescando(id){
            if (!id) return;
            this.$set(this.refrescandoIds, id, true);
        },
        desmarcarRefrescando(id){
            if (!id) return;
            this.$delete(this.refrescandoIds, id);
        },
        estaRefrescando(item){
            return !!this.refrescandoIds[item?.id];
        },
        fichasPendientes(item){
            const totales   = Number(item?.fichas_totales ?? 0);
            const revisadas = Number(item?.fichas_revisadas ?? 0);
            const descartadas = Number(item?.fichas_descartadas ?? 0);
            const pend = totales - revisadas - descartadas;
            return pend > 0 ? pend : 0;
        },
        opcionesTransferirDestino(){
            const origenId = Number(this.transferirItem?.laborante_id || 0);
            const labs = (this.laborantes || []).map(u => ({
                id: u.id,
                name: u.name,
                sede: u.sede,
                rolTipo: 'Laborante',
            }));
            const coords = (this.usuarios || []).map(u => ({
                id: u.id,
                name: u.name,
                sede: u.sede,
                rolTipo: 'Coordinador',
            }));
            const all = [...labs, ...coords].filter(o => Number(o.id) !== origenId);
            const seen = new Set();
            const uniq = all.filter(o => (seen.has(o.id) ? false : (seen.add(o.id), true)));
            uniq.sort((a, b) => (a.name || '').localeCompare(b.name || ''));
            return uniq;
        },
        labelTransferirDestino(opt){
            if (!opt) return '';
            const sede = opt.sede ? ` — ${opt.sede}` : '';
            return `${opt.name}${sede} (${opt.rolTipo})`;
        },
        abrirTransferirModal(item){
            if (this.user.rol === 'Laborante') return;
            if (Boolean(item?.finalizada)) {
                Swal.fire({
                    icon: 'warning',
                    title: 'Asociación finalizada',
                    text: 'No se pueden transferir fichas en una asociación finalizada.',
                });
                return;
            }
            const pend = this.fichasPendientes(item);
            if (!pend) {
                Swal.fire({
                    icon: 'info',
                    title: 'Sin fichas pendientes',
                    text: 'Esta asociación no tiene fichas pendientes para transferir.',
                });
                return;
            }
            this.transferirItem = item;
            this.transferirDestino = null;
            this.$nextTick(() => {
                if (this.$refs['modal-transferir']) {
                    this.$refs['modal-transferir'].show();
                }
            });
        },
        async confirmarTransferir(){
            if (!this.transferirItem || !this.transferirDestino) {
                Swal.fire({
                    icon: 'warning',
                    title: 'Selecciona un destino',
                    text: 'Debes elegir un laborante o coordinador destino.',
                });
                return;
            }
            const item = this.transferirItem;
            const destinoId = Number(this.transferirDestino.id);
            const origenId  = Number(item.laborante_id);
            if (destinoId === origenId) {
                Swal.fire({
                    icon: 'warning',
                    title: 'Destino inválido',
                    text: 'El destino no puede ser el mismo laborante.',
                });
                return;
            }
            const pend = this.fichasPendientes(item);
            const destinoName = this.labelTransferirDestino(this.transferirDestino) || destinoId;
            const confirm = await Swal.fire({
                icon: 'question',
                title: '¿Transferir fichas pendientes?',
                html: `Se transferirán <strong>${pend}</strong> fichas pendientes del laborante <strong>${item.laborante?.name || origenId}</strong> a <strong>${destinoName}</strong>.<br><br>Las fichas ya revisadas o descartadas <strong>no se moverán</strong>.`,
                showCancelButton: true,
                confirmButtonText: 'Sí, transferir',
                cancelButtonText: 'Cancelar',
            });
            if (!confirm.isConfirmed) return;

            this.isTransferring = true;
            const refreshRowId = item.id;
            this.marcarRefrescando(refreshRowId);
            try {
                const { data } = await axios.post('/api/transferir_fichas_pendientes', {
                    evento_id: item.evento_id,
                    origen_laborante_id: origenId,
                    destino_laborante_id: destinoId,
                });
                if (data && data.success) {
                    if (this.$refs['modal-transferir']) this.$refs['modal-transferir'].hide();
                    this.transferirItem = null;
                    this.transferirDestino = null;
                    // Refrescar solo las filas afectadas (origen + destino).
                    const destinoId = data.asociacion_destino_id;
                    const origenIdResp = data.asociacion_origen_id || refreshRowId;
                    if (destinoId) this.marcarRefrescando(destinoId);
                    await Promise.all([
                        this.refreshAsociadoById(origenIdResp),
                        destinoId ? this.refreshAsociadoById(destinoId) : Promise.resolve(),
                    ]);
                    if (destinoId) this.desmarcarRefrescando(destinoId);
                    Swal.fire({
                        icon: 'success',
                        title: 'Transferencia completada',
                        text: data.message || `Se transfirieron ${data.transferidas ?? 0} fichas.`,
                        timer: 2500,
                        showConfirmButton: false,
                    });
                } else {
                    Swal.fire({
                        icon: 'error',
                        title: 'No se pudo transferir',
                        text: (data && data.message) || 'Error transfiriendo fichas pendientes.',
                    });
                }
            } catch (e) {
                const msg = e?.response?.data?.message || 'Error transfiriendo fichas pendientes.';
                Swal.fire({ icon: 'error', title: 'Error', text: msg });
            } finally {
                this.desmarcarRefrescando(refreshRowId);
                this.isTransferring = false;
            }
        },
        formatFecha(fecha) {
            if (!fecha) return '-';
            // Si usas moment.js:
            return moment(fecha).format('DD/MM/YYYY');
            // Si no usas moment, puedes usar:
            // return new Date(fecha).toLocaleDateString();
        },
        progreso(item) {
            return Number(item?.porcentaje_avance || 0);
        },
        crmPorcentajeExito(item) {
            return Number(item?.crm_porcentaje_exito || 0);
        },
        crmResumen(item) {
            const exitosos = Number(item?.crm_exitosos || 0);
            const fallidos = Number(item?.crm_fallidos || 0);
            const pendientes = Number(item?.crm_duplicados || 0);
            return `OK: ${exitosos} | Error: ${fallidos} | Dup: ${pendientes}`;
        },
        crmReenviables(item) {
            return Number(item?.crm_reenviables || 0);
        },
        resumenRdf(item) {
            const revisadas = Number(item?.fichas_revisadas ?? 0);
            const descartadas = Number(item?.fichas_descartadas ?? 0);
            const faltantes = Number(item?.fichas_faltantes ?? 0);
            return `${revisadas}/${descartadas}/${faltantes}`;
        },
        canVaciar(item) {
            if (!this.canManageCleanupButtons) return false;
            if (Boolean(item?.finalizada)) return false;
            return Boolean(item?.puede_vaciar);
        },
        canEliminarAsociacion(item) {
            if (!this.canManageCleanupButtons) return false;
            if (Boolean(item?.finalizada)) return false;
            return Boolean(item?.puede_eliminar);
        },
        canReenviarAsociacion(item) {
            if (!this.canReenviarCrmButtons) return false;
            if (Boolean(item?.finalizada)) return false;
            return this.crmReenviables(item) > 0;
        },
        reenviarAsociacionTooltip(item) {
            if (!this.canReenviarCrmButtons) return '';
            if (Boolean(item?.finalizada)) return 'La asociación está finalizada y no permite reenvíos.';
            if (this.canReenviarAsociacion(item)) return 'Marcar fichas enviadas con éxito para reenvío al CRM';
            return 'No hay fichas válidas con estado enviado_ok para reenviar';
        },
        estaFinalizando(item) {
            return Boolean(item && this.finalizandoIds[item.id]);
        },
        canFinalizar(item) {
            if (!this.user || this.user.rol == 'Laborante') return false;
            if (!item) return false;
            return Boolean(item.puede_finalizar) && !Boolean(item.finalizada) && !this.estaFinalizando(item);
        },
        finalizarTooltip(item) {
            if (!this.user || this.user.rol == 'Laborante') return '';
            if (!item) return '';
            if (this.estaFinalizando(item)) return 'Finalizando fichas...';
            if (Boolean(item.finalizada)) return 'Estas fichas ya fueron finalizadas.';
            if (Number(item?.fichas_totales ?? 0) === 0) return 'No hay fichas cargadas para finalizar.';
            if (this.progreso(item) < 100) return 'Solo se puede finalizar cuando el avance esté al 100%.';
            return 'Finalizar fichas';
        },
        vaciarTooltip(item) {
            if (!this.canManageCleanupButtons) return '';
            if (Boolean(item?.finalizada)) return 'La asociación está finalizada y no permite vaciar fichas.';
            if (this.canVaciar(item)) return 'Eliminar todas las fichas cargadas para esta asociación';
            if (Boolean(item?.digitalizacion_iniciada)) return 'Solo se puede vaciar cuando todavía no existan fichas revisadas o ya procesadas';
            return 'No hay fichas cargadas para vaciar';
        },
        eliminarTooltip(item) {
            if (!this.canManageCleanupButtons) return '';
            if (Boolean(item?.finalizada)) return 'La asociación está finalizada y no permite eliminarse.';
            if (this.canEliminarAsociacion(item)) return 'Eliminar la asociación cuando ya no existen fichas asociadas';
            return 'Primero debe vaciar todas las fichas de esta asociación';
        },

        // confirmar antes de eliminar
        confirmEliminarAsociacion(item) {
            if (!this.canEliminarAsociacion(item)) {
                Swal.fire({
                    icon: 'warning',
                    title: 'Acción no permitida',
                    text: 'Solo puedes eliminar la asociación cuando no existan fichas asociadas al evento.'
                });
                return;
            }
            Swal.fire({
                title: 'Eliminar asociación',
                text: `¿Confirma eliminar la asociación del laborante ${item.laborante?.name || item.laborante_id} con el evento ${item.evento?.codigo || item.evento_id}?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Sí, eliminar',
                confirmButtonColor: "#C87838",
                cancelButtonText: 'Cancelar'
            }).then((result) => {
                if (result.isConfirmed) {
                    this.eliminarAsociacion(item);
                }
            });
        },

        // llamada al backend para eliminar y refrescar lista
        eliminarAsociacion(item) {
            this.isLoading = true;
            axios.post('/api/desasociarLabEvento', { id: item.id })
                .then(response => {
                    Swal.fire({
                        icon: 'success',
                        title: 'Asociación eliminada',
                        text: 'La asociación se eliminó correctamente.'
                    });
                    // refrescar lista de asociados
                    this.refreshAsociados();
                })
                .catch(error => {
                    console.error(error);
                    Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        text: 'No se pudo eliminar la asociación.'
                    });
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },

        confirmForceEliminarAsociacion(item) {
            Swal.fire({
                icon: 'warning',
                title: '⚠️ Eliminar forzado',
                html: `Se eliminarán <strong>todas las fichas</strong> (sin importar el estado) y la asociación del laborante <strong>${item.laborante?.name || item.laborante_id}</strong> con el evento <strong>${item.evento?.codigo || item.evento_id}</strong>.<br><br>Esta acción <strong>no se puede deshacer</strong>.`,
                showCancelButton: true,
                confirmButtonText: 'Sí, eliminar todo',
                cancelButtonText: 'Cancelar',
                confirmButtonColor: '#d33',
            }).then(result => {
                if (result.isConfirmed) this.forceEliminarAsociacion(item);
            });
        },

        forceEliminarAsociacion(item) {
            this.isLoading = true;
            axios.post('/api/force_eliminar_asociacion', { id: item.id })
                .then(() => {
                    Swal.fire({ icon: 'success', title: 'Eliminado', text: 'Asociación y fichas eliminadas.' });
                    this.refreshAsociados();
                })
                .catch(error => {
                    Swal.fire({ icon: 'error', title: 'Error', text: error.response?.data?.message || 'No se pudo eliminar.' });
                })
                .finally(() => { this.isLoading = false; });
        },

        // reutilizable: recargar asociaciones según rol (usado en mounted y tras cambios)
        refreshAsociados() {
            const params = this.user.rol === 'Laborante' ? { estado: 'activos' } : {};
            return axios.get('/api/get_asociados', { params }).then(response => {
                const filtrados = this._filtrarAsociadosPorRol(response.data.asociados || []);
                this.asociaciones = this._dedupeAsociadosPorPar(filtrados);
            }).catch(err => {
                console.error('Error recargando asociados', err);
            });
        },

        // Aplica el filtro estándar de rol (Admin ve todo, Laborante solo sus filas,
        // resto por sede). Centralizado para que mounted, refreshAsociados y la
        // carga en paralelo de finalizadas usen exactamente las mismas reglas.
        _filtrarAsociadosPorRol(asociados) {
            if (!Array.isArray(asociados)) return [];
            if (this.user.rol === 'Admin') return asociados;
            if (this.user.rol === 'Laborante') {
                return asociados.filter(us => us.laborante_id == this.user.id);
            }
            return asociados.filter(us => us.laborante && us.laborante.sede == this.user.sede);
        },

        _dedupeAsociadosPorPar(asociados) {
            if (!Array.isArray(asociados)) return [];
            const byPair = new Map();
            asociados.forEach((item) => {
                const key = `${Number(item?.evento_id || 0)}:${Number(item?.laborante_id || 0)}`;
                const prev = byPair.get(key);
                if (!prev || Number(item?.id || 0) > Number(prev?.id || 0)) {
                    byPair.set(key, item);
                }
            });
            return Array.from(byPair.values());
        },

        /**
         * Refresca SOLO una fila por id. Mucho más rápido que recargar
         * todas las asociaciones (que hace N*~12 queries).
         * Si la asociación no existe aún en el array (caso transferencia
         * a un destino nuevo) la inserta. Si no existe en backend la quita.
         */
        refreshAsociadoById(id) {
            if (!id) return Promise.resolve();
            return axios.get(`/api/get_asociado/${id}`).then(response => {
                if (!response.data || !response.data.success) return;
                const fresh = response.data.asociado;
                if (!fresh) return;
                if ((fresh.comentario || '').toString().trim() !== 'Imagenes') return;
                // Filtro por rol (mismas reglas que refreshAsociados)
                if (this.user.rol === 'Laborante' && fresh.laborante_id != this.user.id) return;
                if (this.user.rol !== 'Admin' && this.user.rol !== 'Laborante'
                    && fresh.laborante && fresh.laborante.sede != this.user.sede) return;

                const idx = this.asociaciones.findIndex(a =>
                    Number(a.id) === Number(fresh.id)
                    || (Number(a.evento_id) === Number(fresh.evento_id)
                        && Number(a.laborante_id) === Number(fresh.laborante_id))
                );
                if (idx >= 0) {
                    this.$set(this.asociaciones, idx, fresh);
                } else {
                    this.asociaciones.push(fresh);
                }
                this.asociaciones = this._dedupeAsociadosPorPar(this.asociaciones);
            }).catch(err => {
                if (err?.response?.status === 404) {
                    // ya no existe -> quitar del array
                    const idx = this.asociaciones.findIndex(a => a.id === id);
                    if (idx >= 0) this.asociaciones.splice(idx, 1);
                } else {
                    console.error('Error refrescando asociado', id, err);
                }
            });
        },

        confirmVaciarImagenes(item) {
            if (!this.canVaciar(item)) {
                Swal.fire({
                    icon: 'warning',
                    title: 'Acción no permitida',
                    text: Boolean(item?.digitalizacion_iniciada)
                        ? 'Solo puedes vaciar las fichas cuando todavía no existan fichas revisadas o ya procesadas.'
                        : 'No hay fichas cargadas para vaciar en esta asociación.'
                });
                return;
            }
            Swal.fire({
                title: 'Vaciar imágenes',
                text: `¿Confirma eliminar todas las imágenes digitalizadas del laborante ${item.laborante?.name || item.laborante_id} para el evento ${item.evento?.codigo || item.evento_id}? Esta acción no se puede deshacer.`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Sí, eliminar',
                confirmButtonColor: "#C87838",
                cancelButtonText: 'Cancelar'
            }).then((result) => {
                if (result.isConfirmed) {
                    this.vaciarImagenes(item);
                }
            });
        },

        vaciarImagenes(item) {
            this.isLoading = true;
            axios.post('/api/vaciarImagenesEvento', {
                evento_id: item.evento_id,
                laborante_id: item.laborante_id,
                asociacion_id: item.id
            }).then(response => {
                if (response.data && response.data.success) {
                    Swal.fire({
                        icon: 'success',
                        title: 'Registros eliminados',
                        text: `${response.data.deleted_count} registro(s) eliminados`
                    });
                    this.refreshAsociados();
                } else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        text: response.data?.message || 'No se pudo vaciar los registros.'
                    });
                }
            }).catch(error => {
                console.error('vaciarImagenes error', error);
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: error.response?.data?.message || 'No se pudo vaciar los registros.'
                });
            }).finally(() => {
                this.isLoading = false;
            });
        },
        confirmReenviarAsociacion(item) {
            if (!this.canReenviarAsociacion(item)) {
                Swal.fire({
                    icon: 'warning',
                    title: 'Acción no permitida',
                    text: this.reenviarAsociacionTooltip(item) || 'No hay fichas para reenviar en esta asociación.'
                });
                return;
            }

            const total = this.crmReenviables(item);
            Swal.fire({
                title: 'Reenviar al CRM',
                text: `¿Confirma marcar ${total} ficha(s) enviadas como pendientes de envío para esta asociación?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Sí, reenviar',
                cancelButtonText: 'Cancelar',
                confirmButtonColor: '#007bff'
            }).then((result) => {
                if (result.isConfirmed) {
                    this.reenviarAsociacion(item);
                }
            });
        },
        reenviarAsociacion(item) {
            this.isLoading = true;
            axios.post('/api/reenviar_asociacion_crm', {
                evento_id: item.evento_id,
                laborante_id: item.laborante_id
            }).then((response) => {
                Swal.fire({
                    icon: 'success',
                    title: 'Reenvío programado',
                    text: response.data?.message || 'Las fichas se marcaron para reenvío.'
                });
                this.refreshAsociados();
            }).catch((error) => {
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: error.response?.data?.message || 'No se pudo marcar las fichas para reenvío.'
                });
            }).finally(() => {
                this.isLoading = false;
            });
        },
        confirmFinalizar(item) {
            if (!this.canFinalizar(item)) {
                Swal.fire({
                    icon: 'warning',
                    title: 'Acción no permitida',
                    text: this.finalizarTooltip(item) || 'No se puede finalizar esta asociación todavía.'
                });
                return;
            }
            Swal.fire({
                title: 'Finalizar fichas',
                text: `¿Confirma finalizar las fichas de ${item.laborante?.name || 'usuario'} para el evento ${item.evento?.codigo || item.evento_id}?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Sí, finalizar',
                cancelButtonText: 'Cancelar',
                confirmButtonColor: '#28a745'
            }).then((result) => {
                if (result.isConfirmed) {
                    this.finalizarFichas(item);
                }
            });
        },
        finalizarFichas(item) {
            this.isLoading = true;
            this.$set(this.finalizandoIds, item.id, true);
            axios.post('/api/finalizarLabEvento', { id: item.id })
                .then((response) => {
                    Swal.fire({
                        icon: 'success',
                        title: 'Finalizado',
                        text: response.data?.message || 'Las fichas se finalizaron correctamente.'
                    });
                    this.refreshAsociados();
                })
                .catch((error) => {
                    Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        text: error.response?.data?.message || 'No se pudo finalizar las fichas.'
                    });
                })
                .finally(() => {
                    this.$delete(this.finalizandoIds, item.id);
                    this.isLoading = false;
                });
        },
        obtenerNombreTipo(tipo_id) {
            if (!tipo_id) return '-';
            const tipo = this.tipos.find(t => t.codigo == tipo_id);
            return tipo ? tipo.nombre : '-';
        },
        toggleSort(key) {
            if (this.sortKey === key) {
                this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc';
            } else {
                this.sortKey = key;
                this.sortOrder = 'asc';
            }
        },
        sortIcon(key) {
            if (this.sortKey !== key) return 'bx bx-sort';
            return this.sortOrder === 'asc' ? 'bx bx-sort-up' : 'bx bx-sort-down';
        },
        descargarExcel() {
            const filas = this.filteredData.map(item => ({
                'Laborante': item.laborante?.name || '-',
                'RUT': item.laborante?.rut || '-',
                'Coordinador': this.obtenerNombreCoordinador(item.evento?.coordinador_evento, item.evento) || '-',
                'Sede': item.laborante?.sede || '-',
                'Evento': item.evento?.nombre_difusion || item.evento?.codigo || '-',
                'Código Evento': item.evento?.codigo || '-',
                'Tipo': this.obtenerNombreTipo(item.evento?.tipo_codigo),
                'Creado': this.formatFecha(item.created_at),
                'Totales': Number(item.fichas_totales ?? 0),
                'Revisadas': Number(item.fichas_revisadas ?? 0),
                'Descartadas': Number(item.fichas_descartadas ?? 0),
                'Faltantes': Number(item.fichas_faltantes ?? 0),
                'Error CRM': Number(item.crm_fallidos ?? 0),
                'Duplicados CRM': Number(item.crm_duplicados ?? 0),
                'Avance (%)': this.progreso(item),
                'Finalizada': item.finalizada ? 'Sí' : 'No',
            }));
            const totalTotales = filas.reduce((s, r) => s + r['Totales'], 0);
            const totalRevisadas = filas.reduce((s, r) => s + r['Revisadas'], 0);
            const totalDescartadas = filas.reduce((s, r) => s + r['Descartadas'], 0);
            const totalFaltantes = filas.reduce((s, r) => s + r['Faltantes'], 0);
            const totalErroresCrm = filas.reduce((s, r) => s + r['Error CRM'], 0);
            const totalPendientesCrm = filas.reduce((s, r) => s + r['Duplicados CRM'], 0);
            filas.push({
                'Laborante': 'TOTAL',
                'RUT': '',
                'Coordinador': '',
                'Sede': '',
                'Evento': '',
                'Código Evento': '',
                'Tipo': '',
                'Creado': '',
                'Totales': totalTotales,
                'Revisadas': totalRevisadas,
                'Descartadas': totalDescartadas,
                'Faltantes': totalFaltantes,
                'Error CRM': totalErroresCrm,
                'Duplicados CRM': totalPendientesCrm,
                'Avance (%)': '',
                'Finalizada': '',
            });
            const worksheet = XLSX.utils.json_to_sheet(filas);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, 'Asociaciones');
            const fecha = new Date().toISOString().slice(0, 10);
            XLSX.writeFile(workbook, `asociaciones_eventos_${fecha}.xlsx`);
        },
        reprocesarTodosLosPendientes() {
            this.reprocesandoTodos = true;
            axios.post('/api/reprocesar_todos_pendientes')
                .then(response => {
                    Swal.fire({
                        icon: 'success',
                        title: 'Reproceso completado',
                        text: response.data?.message || 'Se reprocesaron los registros pendientes.'
                    });
                    this.refreshAsociados();
                })
                .catch(error => {
                    Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        text: error.response?.data?.message || 'No se pudieron reprocesar los pendientes.'
                    });
                })
                .finally(() => {
                    this.reprocesandoTodos = false;
                });
        },
        aplicarFiltrosPredeterminadosCoordinador() {
            if (this.filtrosPredeterminadosAplicados) return;
            if (!this.user || this.user.rol !== 'Coordinador') return;

            if (this.user.sede) {
                this.filtroSede = this.user.sede;
            }

            const nombreUsuario = (this.user.name || '').toString().trim();
            if (nombreUsuario) {
                const coordinadorCoincidente = this.coordinadoresDisponibles
                    .find(opt => this.normalizarTexto(opt.value) === this.normalizarTexto(nombreUsuario));

                // Si no hay coincidencia real, no forzar filtro de coordinador
                // para evitar dejar la tabla vacía por diferencias de texto.
                this.filtroCoordinador = coordinadorCoincidente ? coordinadorCoincidente.value : '';
            }

            this.filtrosPredeterminadosAplicados = true;
        },
    },
    mounted(){
        this.isLoading = true;
        this.isInitialLoading = true;
    const esLaborante = this.user && this.user.rol === 'Laborante';

        // 1) Carga PRIORITARIA: asociados activos. Apenas vuelve, se libera el loader
        //    y la tabla se vuelve usable, aunque las llamadas auxiliares sigan en curso.
        const activosPromise = axios.get('/api/get_asociados?estado=activos').then(response => {
            const filtrados = this._filtrarAsociadosPorRol(response.data.asociados || []);
            this.asociaciones = this._dedupeAsociadosPorPar(filtrados);
            this.aplicarFiltrosPredeterminadosCoordinador();
        }).catch(error => {
            console.error('Error cargando asociados activos', error);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'No se pudieron cargar los registros activos.'
            });
        }).finally(() => {
            // Libera la pantalla de carga aunque las llamadas auxiliares aún no terminen.
            this.isInitialLoading = false;
            this.isLoading = false;
        });

        // 2) Llamadas auxiliares en paralelo, independientes entre sí.
        //    No bloquean la visualización de la tabla.
        if (!esLaborante) {
            axios.get('/api/get_tipos').then(r => {
                this.tipos = r.data.tipos;
            }).catch(err => console.error('Error cargando tipos', err));

            axios.get('/api/get_laborantes').then(r => {
                if (this.user.rol == 'Admin') {
                    this.laborantes = r.data.usuarios;
                } else {
                    this.laborantes = r.data.usuarios.filter(us => us.sede == this.user.sede);
                }
            }).catch(err => console.error('Error cargando laborantes', err));

            axios.get('/api/get_eventos').then(r => {
                this.eventos = r.data.eventos;
            }).catch(err => console.error('Error cargando eventos', err));

            axios.get('/api/get_usuarios').then(r => {
                this.usuarios = r.data.usuarios;
                this.aplicarFiltrosPredeterminadosCoordinador();
            }).catch(err => console.error('Error cargando usuarios', err));
        }

        // 3) Cargar finalizadas en paralelo. Disparamos el request YA, pero el
        //    merge se hace DESPUÉS de que activos termine, para evitar carrera
        //    (si finalizadas resolviera antes, activos pisaría el array).
        if (!esLaborante) {
            this.loadingFinalizadas = true;
            const finalizadasPromise = axios.get('/api/get_asociados?estado=finalizadas');
            Promise.all([activosPromise, finalizadasPromise]).then(([_, response]) => {
                const finalizadas = this._filtrarAsociadosPorRol(response.data.asociados || []);
                if (!finalizadas.length) return;
                // Fusionar sin duplicar (por id).
                const idsActuales = new Set(this.asociaciones.map(a => a.id));
                const nuevas = finalizadas.filter(a => !idsActuales.has(a.id));
                this.asociaciones = this._dedupeAsociadosPorPar(this.asociaciones.concat(nuevas));
            }).catch(err => {
                console.error('Error cargando finalizadas', err);
            }).finally(() => {
                this.loadingFinalizadas = false;
            });
        }

        // Cargar concluidos en paralelo (no bloquea la carga principal)
        if (!esLaborante) {
            this.loadingConcluidos = true;
            axios.get('/api/get_pagos_digitalizacion').then(response => {
                this.pagosDigitalizacion = response.data.pagos || [];
            }).catch(err => {
                console.error('Error cargando concluidos', err);
            }).finally(() => {
                this.loadingConcluidos = false;
            });
        }
    }
};
</script>
<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <loading-message v-if="isInitialLoading" />
        <div v-else>

        <!-- Resumen estadístico -->
        <div class="row mb-3" v-if="canVerStats && asociaciones.length">
            <div class="col-12">
                <div class="card shadow-sm mb-0">
                    <div class="card-body py-2 px-3">
                        <div class="d-flex flex-wrap align-items-center" style="gap: 0.5rem;">
                            <span class="badge badge-pill" style="background:#fd7e14; color:#fff; font-size:0.82rem; padding:0.4em 0.8em;">
                                <i class="bx bx-time-five"></i>
                                Fichas pend. revisión: <strong>{{ statsPendientesRevision }}</strong>
                            </span>
                            <span class="badge badge-pill badge-primary" style="font-size:0.82rem; padding:0.4em 0.8em;">
                                Asoc. en progreso: <strong>{{ statsAsocPendientes }}</strong>
                            </span>
                            <span class="badge badge-pill badge-success" style="font-size:0.82rem; padding:0.4em 0.8em;">
                                Revisadas sin finalizar: <strong>{{ statsAsocRevisadasSinFinalizar }}</strong>
                            </span>
                            <span class="badge badge-pill badge-danger" style="font-size:0.82rem; padding:0.4em 0.8em;">
                                Errores CRM: <strong>{{ statsErroresCrm }}</strong>
                            </span>
                            <span class="badge badge-pill badge-secondary" style="font-size:0.82rem; padding:0.4em 0.8em;">
                                Descartes: <strong>{{ statsDescartes }}</strong>
                            </span>
                            <b-button
                                v-if="canViewCrmStats"
                                size="sm"
                                variant="warning"
                                :disabled="reprocesandoTodos"
                                @click="reprocesarTodosLosPendientes"
                                class="ml-auto"
                                title="Reprocesar todos los registros Pendiente desde S3"
                            >
                                <i class="bx bx-refresh mr-1"></i>
                                {{ reprocesandoTodos ? 'Reprocesando...' : 'Reprocesar todos los pendientes' }}
                            </b-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Fin resumen -->

        <div class="row">
            <div class="col-12">
                <div class="card" v-if="user.rol!='Laborante'">
                    <div class="card-body">
                        <b-button variant="primary" @click="ver_boton" v-if="!ver">Agregar</b-button>
                        <div class="row" v-if="ver">
                            <div class="col-md-12">
                                <b-form-group label="Quien Asociar" v-slot="{ ariaDescribedby }">
                                    <b-form-radio v-model="selected" :aria-describedby="ariaDescribedby" name="some-radios" value="Laborante">Laborante</b-form-radio>
                                    <b-form-radio v-model="selected" :aria-describedby="ariaDescribedby" name="some-radios" value="Coordinador">Coordinador</b-form-radio>
                                </b-form-group>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group row" v-if="selected==='Laborante'">
                                    <div class="col-md-6">
                                        <label for="pais"> Laborante:</label>
                                    </div>
                                    <div class="col-md-6 text-right">
                                        <label for="pais" class="text-primary"> * Campo Obligatorio</label>
                                    </div>
                                    <div class="col-md-12">
                                        <multiselect
                                            v-model="lab.laborante"
                                            :options="laborantes"
                                            placeholder="Seleccionar laborante"
                                            selectLabel="Presiona para seleccionar"
                                            selectedLabel="Seleccionado"
                                            deselectLabel="Presiona para remover"
                                            :custom-label="labelselect_laborante"
                                            >
                                            <template v-slot:noOptions>
                                                <p>No hay opciones</p>
                                            </template>
                                            <template v-slot:noResult>
                                                <p>No se encuentra coincidencia</p>
                                            </template>
                                        </multiselect>
                                    </div>
                                </div>
                                <div class="form-group row" v-else-if="selected==='Coordinador'">
                                    <div class="col-md-6">
                                        <label for="pais"> Coordinador:</label>
                                    </div>
                                    <div class="col-md-6 text-right">
                                        <label for="pais" class="text-primary"> * Campo Obligatorio</label>
                                    </div>
                                    <div class="col-md-12">
                                        <multiselect
                                            v-model="lab.laborante"
                                            :options="usuarios"
                                            placeholder="Seleccionar coordinador"
                                            selectLabel="Presiona para seleccionar"
                                            selectedLabel="Seleccionado"
                                            deselectLabel="Presiona para remover"
                                            :custom-label="labelselect_laborante"
                                            >
                                            <template v-slot:noOptions>
                                                <p>No hay opciones</p>
                                            </template>
                                            <template v-slot:noResult>
                                                <p>No se encuentra coincidencia</p>
                                            </template>
                                        </multiselect>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6" v-if="selected!=''">
                                <div class="form-group row">
                                    <div class="col-md-6">
                                        <label for="pais"> Evento:</label>
                                    </div>
                                    <div class="col-md-6 text-right">
                                        <label for="pais" class="text-primary"> * Campo Obligatorio</label>
                                    </div>
                                    <div class="col-md-12">
                                        <multiselect
                                            v-model="lab.event"
                                            :options="eventos"
                                            placeholder="Seleccionar evento"
                                            selectLabel="Presiona para seleccionar"
                                            selectedLabel="Seleccionado"
                                            deselectLabel="Presiona para remover"
                                            :custom-label="labelEvento"
                                            >
                                            <template v-slot:noOptions>
                                                <p>No hay opciones</p>
                                            </template>
                                            <template v-slot:noResult>
                                                <p>No se encuentra coincidencia</p>
                                            </template>
                                        </multiselect>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-12 text-right">
                                <b-button variant="secondary" @click="cancelar">Cancelar</b-button>
                                <b-button variant="primary" @click="asociar">Asociar</b-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <div class="d-flex flex-wrap align-items-center justify-content-between gap-2 mb-3">
                            <div class="d-flex align-items-center flex-wrap gap-2">
                                <label class="d-inline-flex align-items-center mb-0">
                                    Mostrar&nbsp;
                                    <b-form-select v-model="perPage" size="sm" :options="pageOptions" class="mx-1"></b-form-select>
                                </label>
                                <span class="text-muted" style="white-space: nowrap; font-size: 0.875rem;">Total: <strong>{{ rows }}</strong> registros</span>
                                <b-form-checkbox
                                    v-if="canViewFinalizadosControls"
                                    v-model="mostrarFinalizados"
                                    switch
                                    class="mb-0 ml-2"
                                    :disabled="loadingFinalizadas"
                                >
                                    Mostrar finalizados
                                </b-form-checkbox>
                                <b-form-checkbox v-if="canViewFinalizadosControls" v-model="soloListosParaFinalizar" switch class="mb-0 ml-2" style="white-space: nowrap;">
                                    Listos para finalizar
                                </b-form-checkbox>
                            </div>
                            <div class="d-flex align-items-center flex-wrap gap-2">
                                <b-form-select
                                    v-model="filtroSede"
                                    :options="sedesDisponibles"
                                    size="sm"
                                    style="width: 180px;"
                                ></b-form-select>
                                <b-form-select
                                    v-model="filtroCoordinador"
                                    :options="coordinadoresDisponibles"
                                    size="sm"
                                    style="width: 200px;"
                                ></b-form-select>
                                <b-form-select
                                    v-model="filtroLaborante"
                                    :options="laborantesDisponibles"
                                    size="sm"
                                    style="width: 200px;"
                                ></b-form-select>
                                <label class="d-inline-flex align-items-center mb-0">
                                    <b-form-input
                                        v-model="filtro"
                                        type="search"
                                        placeholder="Buscar..."
                                        class="form-control form-control-sm"
                                        style="width: 200px;"
                                    ></b-form-input>
                                </label>
                                <b-button size="sm" variant="success" @click="descargarExcel">
                                    <i class="bx bx-download mr-1"></i> Excel
                                </b-button>
                            </div>
                        </div>
                        <div v-if="loadingFinalizadas" class="text-muted small mt-2" style="font-style: italic;">
                            <b-spinner small variant="secondary" class="mr-1"></b-spinner>
                            Cargando registros finalizados en segundo plano...
                        </div>
                        <div class="table-responsive mb-0 mt-3">
                            <table class="table table-hover">
                                <thead>
                                    <tr>
                                        <th style="width: 13%;">Laborante</th>
                                        <th style="width: 13%;">Coordinador</th>
                                        <th style="width: 16%;">Evento</th>
                                        <th style="width: 10%;">Código</th>
                                        <th style="width: 8%;">Tipo</th>
                                        <th style="width: 9%;">Creado</th>
                                        <th style="width: 12%;">Archivo</th>
                                        <th style="width: 7%;">Totales</th>
                                        <th style="white-space: nowrap; cursor: pointer;" @click="toggleSort('revisadas')">
                                            Revisadas <i :class="sortIcon('revisadas')"></i>
                                        </th>
                                        <th style="white-space: nowrap; cursor: pointer;" @click="toggleSort('descartadas')">
                                            Desc <i :class="sortIcon('descartadas')"></i>
                                        </th>
                                        <th style="white-space: nowrap; cursor: pointer;" @click="toggleSort('faltantes')">
                                            Falt <i :class="sortIcon('faltantes')"></i>
                                        </th>
                                        <th style="width: 8%;">Avance</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr
                                        v-for="(item, index) in paginatedData"
                                        :key="item.id"
                                        :class="{ 'row-refreshing': estaRefrescando(item) }"
                                    >
                                        <td class="laborante-column">
                                            <div class="laborante-name" :title="item.laborante?.name || '-'" style="display: inline-flex; align-items: center; gap: 4px;">
                                                <span>{{ nombreCortoConPuntos(item.laborante?.name) }}</span>
                                                <i v-if="item.laborante?.name" class="bx bx-info-circle" style="font-size: 0.85rem; color: #8a8f98;"></i>
                                            </div>
                                            <div class="laborante-rut">{{ item.laborante?.rut || '-' }}</div>
                                        </td>
                                        <td class="laborante-column">
                                            <div class="laborante-name" :title="obtenerNombreCoordinador(item.evento?.coordinador_evento, item.evento) || '-'" style="display: inline-flex; align-items: center; gap: 4px;">
                                                <span>{{ nombreCortoConPuntos(obtenerNombreCoordinador(item.evento?.coordinador_evento, item.evento)) }}</span>
                                                <i v-if="obtenerNombreCoordinador(item.evento?.coordinador_evento, item.evento)" class="bx bx-info-circle" style="font-size: 0.85rem; color: #8a8f98;"></i>
                                            </div>
                                            <div class="laborante-rut">{{ item.laborante?.sede || '-' }}</div>
                                        </td>
                                        <td>
                                            <div class="laborante-name" :title="item.evento?.nombre_difusion || item.evento?.codigo || '-'" style="display: inline-flex; align-items: center; gap: 4px;">
                                                <span>{{ nombreCortoConPuntos(item.evento?.nombre_difusion || item.evento?.codigo, 2) }}</span>
                                                <i v-if="item.evento?.nombre_difusion || item.evento?.codigo" class="bx bx-info-circle" style="font-size: 0.85rem; color: #8a8f98;"></i>
                                            </div>
                                        </td>
                                        <td>
                                            <div>{{ item.evento?.codigo || '-' }}</div>
                                            <div style="font-size: 0.78rem; color: #8a8f98;">RBD: {{ item.evento?.rbd_colegio || '-' }}</div>
                                        </td>
                                        <td>{{ obtenerNombreTipo(item.evento?.tipo_codigo) }}</td>
                                        <td style="white-space: nowrap; font-size: 0.82rem;">{{ formatFecha(item.created_at) }}</td>
                                        <td>
                                            <template v-if="item.archivos_pdf && item.archivos_pdf.length">
                                                <div v-for="(archivo, idxArchivo) in item.archivos_pdf" :key="`${item.id}-archivo-${idxArchivo}`" style="margin-bottom: 4px;">
                                                    <div :title="archivo.nombre" style="font-size: 0.78rem; line-height: 1.3; display: inline-flex; align-items: center; gap: 4px; flex-wrap: wrap;">
                                                        <span>{{ textoAcotado(archivo.nombre, 24) }}</span>
                                                        <i class="bx bx-info-circle" style="font-size: 0.85rem; color: #8a8f98;"></i>
                                                        <span v-if="archivo.tipo_formulario" :style="estiloTipoFormulario(archivo.tipo_formulario)">{{ etiquetaTipoFormulario(archivo.tipo_formulario) }}</span>
                                                    </div>
                                                    <div style="font-size: 0.72rem; color: #888;">
                                                        {{ archivo.paginas }} páginas<span v-if="archivo.fichas !== null && archivo.fichas !== undefined"> - {{ archivo.fichas }} fichas</span>
                                                    </div>
                                                </div>
                                            </template>
                                            <template v-else>
                                                <div v-if="item.nombre_archivo_pdf" :title="item.nombre_archivo_pdf" style="font-size: 0.78rem; line-height: 1.3; display: inline-flex; align-items: center; gap: 4px; flex-wrap: wrap;">
                                                    <span>{{ textoAcotado(item.nombre_archivo_pdf, 24) }}</span>
                                                    <i class="bx bx-info-circle" style="font-size: 0.85rem; color: #8a8f98;"></i>
                                                    <span v-if="item.tipo_formulario_pdf" :style="estiloTipoFormulario(item.tipo_formulario_pdf)">{{ etiquetaTipoFormulario(item.tipo_formulario_pdf) }}</span>
                                                </div>
                                                <div v-if="item.total_paginas_pdf" style="font-size: 0.72rem; color: #888;">
                                                    {{ item.total_paginas_pdf }} páginas<span v-if="item.total_fichas_pdf !== null && item.total_fichas_pdf !== undefined"> - {{ item.total_fichas_pdf }} fichas</span>
                                                </div>
                                                <span v-if="!item.nombre_archivo_pdf" style="font-size: 0.78rem; color: #aaa;">—</span>
                                            </template>
                                        </td>
                                        <td>{{ item.fichas_totales ?? 0 }}</td>
                                        <td>
                                            <div>{{ item.fichas_revisadas ?? 0 }}</div>
                                            <div style="font-size: 0.72rem; line-height: 1.2; color: #6c757d;">
                                                CRM:
                                                <span style="color: #198754; font-weight: 600;">{{ item.crm_exitosos ?? 0 }}</span>
                                                <span style="color: #6c757d;"> | </span>
                                                <span style="color: #dc3545; font-weight: 600;">Err: {{ item.crm_fallidos ?? 0 }}</span>
                                                <span style="color: #6c757d;"> | </span>
                                                <span style="color: #d39e00; font-weight: 600;">Dup: {{ item.crm_duplicados ?? 0 }}</span>
                                            </div>
                                        </td>
                                        <td>{{ item.fichas_descartadas ?? 0 }}</td>
                                        <td>{{ item.fichas_faltantes ?? 0 }}</td>
                                        <td class="avance-column">
                                            <b-progress :value="progreso(item)" max="100" height="20px" show-progress animated>
                                                <b-progress-bar
                                                    :value="progreso(item)"
                                                    :variant="progreso(item) == 100 ? 'success' : (progreso(item) == 0 ? 'secondary' : 'warning')"
                                                >
                                                    {{ progreso(item) }}%
                                                </b-progress-bar>
                                            </b-progress>
                                        </td>
                                        <td>
                                            <div class="action-buttons">
                                                <div class="action-row">
                                                <b-button class="btn-accion" size="sm" variant="primary" @click="modal_subir_imagenes(item)" v-if="user.rol!='Laborante'" :disabled="Boolean(item.finalizada) || estaRefrescando(item)" :title="estaRefrescando(item) ? 'Actualizando registros recién cargados, espera unos segundos' : (Boolean(item.finalizada) ? 'Asociación finalizada: no se puede subir' : 'Subir fichas')">
                                                    <i class="bx bx-image-add font-size-16"></i> Subir
                                                </b-button>
                                                <b-button
                                                    class="btn-accion"
                                                    size="sm"
                                                    variant="primary"
                                                    @click="href_digitalizar(item)"
                                                    :disabled="Boolean(item.finalizada) || estaRefrescando(item) || digitalizarDisabled || progreso(item) >= 100 || !Number(item.fichas_totales)"
                                                    :title="estaRefrescando(item) ? 'Actualizando registros recién cargados, intenta nuevamente en unos segundos' : (Boolean(item.finalizada) ? 'Asociación finalizada: no se puede digitalizar' : (!Number(item.fichas_totales) ? 'No hay fichas cargadas para digitalizar' : (progreso(item) >= 100 ? 'Todas las fichas ya fueron revisadas' : 'Digitalizar fichas')))"
                                                >
                                                    <i class="bx bx-file-find font-size-16"></i> Digitalizar
                                                </b-button>
                                                <b-button class="btn-accion" size="sm" variant="primary" @click="href_ver(item)" :disabled="estaRefrescando(item)" :title="estaRefrescando(item) ? 'La fila está sincronizando datos' : 'Ver fichas'">
                                                    <i class="bx bx-show-alt font-size-16"></i> Ver
                                                </b-button>
                                                <b-button
                                                    v-if="['Admin', 'Supervisor'].includes(user.rol)"
                                                    class="btn-accion"
                                                    size="sm"
                                                    variant="info"
                                                    :disabled="Boolean(item.finalizada) || estaRefrescando(item) || !fichasPendientes(item)"
                                                    :title="Boolean(item.finalizada) ? 'Asociación finalizada: no se puede transferir' : (fichasPendientes(item) ? `Transferir ${fichasPendientes(item)} fichas pendientes a otro laborante/coordinador` : 'No hay fichas pendientes para transferir')"
                                                    @click="abrirTransferirModal(item)"
                                                >
                                                    <i class="bx bx-transfer font-size-16"></i> Transferir
                                                </b-button>
                                                </div>

                                                <div class="action-row">
                                                <b-button
                                                    v-if="canReenviarCrmButtons"
                                                    class="btn-accion"
                                                    size="sm"
                                                    variant="info"
                                                    :disabled="estaRefrescando(item) || !canReenviarAsociacion(item)"
                                                    :title="reenviarAsociacionTooltip(item)"
                                                    @click="confirmReenviarAsociacion(item)"
                                                >
                                                    <i class="bx bx-refresh font-size-16"></i> Reenviar ({{ crmReenviables(item) }})
                                                </b-button>
                                                <b-button
                                                    class="btn-accion"
                                                    v-if="user.rol!='Laborante'"
                                                    size="sm"
                                                    variant="success"
                                                    :disabled="estaRefrescando(item) || !canFinalizar(item)"
                                                    :title="finalizarTooltip(item)"
                                                    @click="confirmFinalizar(item)"
                                                >{{ estaFinalizando(item) ? 'Finalizando...' : (item.finalizada ? 'Finalizado' : 'Finalizar') }}</b-button>
                                                <!-- Nuevo: botón eliminar asociación (solo id 1) -->
                                                <b-button
                                                    v-if="canManageCleanupButtons"
                                                    class="btn-accion"
                                                    size="sm"
                                                    variant="danger"
                                                    :disabled="estaRefrescando(item) || !canEliminarAsociacion(item)"
                                                    :title="eliminarTooltip(item)"
                                                    @click="confirmEliminarAsociacion(item)"
                                                >
                                                    <i class="bx bx-trash-alt font-size-16"></i>
                                                </b-button>
                                                <!-- Nuevo: botón vaciar imágenes (solo id 1) -->
                                                <b-button
                                                    v-if="canManageCleanupButtons"
                                                    class="btn-accion"
                                                    size="sm"
                                                    variant="warning"
                                                    :disabled="estaRefrescando(item) || !canVaciar(item)"
                                                    :title="vaciarTooltip(item)"
                                                    @click="confirmVaciarImagenes(item)"
                                                >
                                                    <i class="bx bx-trash font-size-16"></i> Vaciar
                                                </b-button>
                                                <!-- Forzar eliminación (solo user id=1) -->
                                                <b-button
                                                    v-if="canForceEliminar"
                                                    class="btn-accion"
                                                    size="sm"
                                                    variant="danger"
                                                    :disabled="estaRefrescando(item)"
                                                    title="Eliminar forzado: borra todas las fichas y la asociación sin restricciones"
                                                    @click="confirmForceEliminarAsociacion(item)"
                                                >
                                                    <i class="bx bx-error font-size-16"></i> Force
                                                </b-button>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="row">
                            <div class="col">
                                <b-alert
                                    v-if="syncingAsociaciones || totalFilasRefrescando > 0"
                                    show
                                    variant="info"
                                    class="py-2 mb-3"
                                >
                                    <b-spinner small class="mr-2"></b-spinner>
                                    Se están actualizando datos recientes.
                                    <span v-if="totalFilasRefrescando > 0">Filas en sincronización: {{ totalFilasRefrescando }}.</span>
                                </b-alert>
                                <div class="dataTables_paginate paging_simple_numbers float-right">
                                    <ul class="pagination pagination-rounded mb-0">
                                        <!-- pagination -->
                                        <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"></b-pagination>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <loading-message
                            v-if="isLoading && loadingOverlayMode"
                            :title="loadingOverlayMode === 'ocr' ? 'Procesando con OCR...' : 'Subiendo archivos...'"
                            :subtitle="loadingOverlayMode === 'ocr' ? 'El OCR puede tardar hasta 2 minutos. No cierre la ventana.' : 'Estamos cargando los archivos seleccionados.'"
                        />
                        <b-modal ref="modal-subir" :title="'Subir imágenes o PDFs'" :ok-title="isLoading ? 'Procesando...' : 'Guardar'" cancel-title="Cancelar" @ok="guardarImagenes" :ok-disabled="isLoading">
                            <!-- Botón que activa el input -->
                            <b-button @click="$refs.inputImagenes.click()" variant="primary" class="mb-2">
                            Añadir imágenes o PDFs
                            </b-button>
                            <small class="text-muted d-block mb-2">
                                Formatos aceptados: JPG, PNG, GIF, PDF. Los PDFs se convertirán automáticamente en imágenes.
                            </small>
                            <small class="text-muted d-block mb-2">
                                Tamaño máximo por archivo: {{ maxFileSizeMb }} MB. Tamaño máximo total por envío: {{ maxTotalSizeMb }} MB.
                            </small>
                            <b-alert
                                v-if="archivosDuplicadosAviso.length"
                                show
                                variant="warning"
                                class="mb-3"
                            >
                                <strong>Archivos duplicados omitidos.</strong>
                                Ya estaban seleccionados o cargados: {{ archivosDuplicadosAviso.join(', ') }}
                            </b-alert>
                            <!-- Input oculto -->
                            <input
                            type="file"
                            ref="inputImagenes"
                            multiple
                            accept="image/*,application/pdf"
                            @change="agregarImagenes"
                            style="display: none;"
                            />
                            <!-- Vista previa de imágenes -->
                            <!-- <div class="d-flex flex-wrap mt-3">
                                <div
                                    v-for="(img, index) in imagenesPreview"
                                    :key="index"
                                    class="position-relative m-2"
                                    style="width: 120px; height: 120px;"
                                >
                                    <img
                                    :src="img"
                                    alt="Imagen"
                                    class="img-thumbnail"
                                    style="width: 100%; height: 100%; object-fit: cover;"
                                    />
                                    <b-button
                                    size="sm"
                                    variant="danger"
                                    class="position-absolute"
                                    style="top: -10px; right: -10px; border-radius: 50%;"
                                    @click="eliminarImagen(index)"
                                    >
                                    ✕
                                    </b-button>
                                </div>
                            </div> -->
                            <!-- Tipo de formulario (solo rol Admin) -->
                            <div v-if="canUseFormularioNuevo" class="mt-3 mb-2 p-2 border rounded">
                                <p class="mb-1 font-weight-bold text-dark" style="font-size:0.9rem;">
                                    <i class="bx bx-file mr-1"></i>Tipo de formulario
                                </p>
                                <b-form-radio-group
                                    v-model="tipoFormulario"
                                    :options="formularioTipoOptions"
                                    stacked
                                />
                                <small v-if="!canUseFormularioV3" class="text-muted d-block mt-1">
                                    <i class="bx bx-lock-alt mr-1"></i>
                                    Digitalizador V3 está visible solo como referencia y desactivado para tu usuario.
                                </small>
                                <small v-if="tipoFormulario === 'v2'" class="text-info d-block mt-1">
                                    <i class="bx bx-info-circle mr-1"></i>
                                    Los archivos PDF serán analizados con reconocimiento óptico de caracteres (OCR). Los datos extraídos quedarán pre-completados para que el laborante los revise y confirme.
                                </small>
                                <small v-else-if="tipoFormulario === 'v3'" class="text-info d-block mt-1">
                                    <i class="bx bx-info-circle mr-1"></i>
                                    V3 procesa solo fichas frontales. Puedes subir un PDF con una o mas paginas, y cada pagina se procesa como una ficha independiente.
                                </small>
                            </div>
                            <draggable
                                v-model="imagenesSeleccionadas"
                                class="d-flex flex-wrap mt-3"
                                :options="{ animation: 150 }"
                            >
                                <transition-group type="transition" name="fade" tag="div" class="d-flex flex-wrap">
                                    <div
                                        v-for="(imgObj, index) in imagenesSeleccionadas"
                                        :key="index*890"
                                        class="position-relative m-2"
                                        style="width: 120px; height: 120px; cursor: grab;"
                                    >
                                        <!-- Preview para imágenes -->
                                        <img
                                            v-if="!imgObj.isPdf"
                                            :src="imgObj.preview"
                                            alt="Imagen"
                                            class="img-thumbnail"
                                            style="width: 100%; height: 100%; object-fit: cover;"
                                        />
                                        <!-- Preview para PDFs -->
                                        <div
                                            v-else
                                            class="d-flex flex-column align-items-center justify-content-center img-thumbnail"
                                            style="width: 100%; height: 100%; background-color: #f8f9fa;"
                                        >
                                            <i class="bx bxs-file-pdf" style="font-size: 32px; color: #dc3545;"></i>
                                            <small class="text-muted text-center mt-1" style="font-size: 10px;">
                                                {{ imgObj.file.name.length > 15 ? imgObj.file.name.substring(0, 12) + '...' : imgObj.file.name }}
                                            </small>
                                        </div>
                                        <b-button
                                            size="sm"
                                            variant="danger"
                                            class="position-absolute"
                                            style="top: -10px; right: -10px; border-radius: 50%;"
                                            @click="eliminarImagen(index)"
                                        >
                                            ✕
                                        </b-button>
                                    </div>
                                </transition-group>
                            </draggable>

                        </b-modal>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal Transferir fichas pendientes -->
        <b-modal
            ref="modal-transferir"
            title="Transferir fichas pendientes"
            :ok-title="isTransferring ? 'Transfiriendo...' : 'Transferir'"
            cancel-title="Cancelar"
            :ok-disabled="isTransferring || !transferirDestino"
            @ok.prevent="confirmarTransferir"
        >
            <div v-if="transferirItem">
                <p class="mb-2">
                    <strong>Evento:</strong> {{ transferirItem.evento?.codigo || transferirItem.evento_id }}
                    <span v-if="transferirItem.evento?.nombre"> — {{ transferirItem.evento.nombre }}</span>
                </p>
                <p class="mb-2">
                    <strong>Laborante origen:</strong> {{ transferirItem.laborante?.name || transferirItem.laborante_id }}
                </p>
                <p class="mb-3">
                    <strong>Fichas pendientes a transferir:</strong>
                    <span class="badge badge-warning">{{ fichasPendientes(transferirItem) }}</span>
                </p>
                <b-form-group label="Destino (laborante o coordinador)">
                    <multiselect
                        v-model="transferirDestino"
                        :options="opcionesTransferirDestino()"
                        :custom-label="labelTransferirDestino"
                        track-by="id"
                        placeholder="Buscar por nombre, sede o rol..."
                        selectLabel="Presiona para seleccionar"
                        selectedLabel="Seleccionado"
                        deselectLabel="Presiona para remover"
                    >
                        <template v-slot:noOptions><p>No hay opciones</p></template>
                        <template v-slot:noResult><p>No se encuentra coincidencia</p></template>
                    </multiselect>
                </b-form-group>
                <small class="text-muted d-block">
                    Las fichas ya revisadas, descartadas o eliminadas <strong>no se moverán</strong>. Solo se transfieren las pendientes.
                </small>
            </div>
        </b-modal>

        <!-- ===== SECCIÓN CONCLUIDOS ===== -->
        <div v-if="canViewEventosConcluidos" class="row mt-3">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <h5 class="card-title mb-3">
                            <i class="bx bx-check-circle text-success mr-1"></i>
                            Eventos concluidos
                            <b-badge variant="success" class="ml-2">{{ pagosDigitalizacion.length }}</b-badge>
                        </h5>
                        <div v-if="loadingConcluidos" class="text-muted">Cargando...</div>
                        <div v-else>
                            <div class="d-flex align-items-center justify-content-between flex-wrap gap-2 mb-3">
                                <b-form-input
                                    v-model="filtroConcluidos"
                                    type="search"
                                    placeholder="Buscar código, laborante, coordinador, colegio..."
                                    size="sm"
                                    style="max-width: 340px;"
                                    @input="currentPageConcluidos = 1"
                                ></b-form-input>
                                <span class="text-muted" style="font-size: 0.875rem;">
                                    Mostrando <strong>{{ rowsConcluidos }}</strong> registros
                                </span>
                            </div>
                            <div class="table-responsive">
                                <table class="table table-sm table-hover">
                                    <thead class="thead-light">
                                        <tr>
                                            <th>Código evento</th>
                                            <th>Colegio</th>
                                            <th>Fecha</th>
                                            <th>Coordinador</th>
                                            <th>Laborante</th>
                                            <th style="text-align:center;">Fichas</th>
                                            <th style="text-align:center;">Rev.</th>
                                            <th style="text-align:center;">Pagables</th>
                                            <th style="text-align:center;">Desc.</th>
                                            <th style="text-align:center;">CRM OK</th>
                                            <th style="text-align:center;">CRM Dup.</th>
                                            <th>Estado pago</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="item in paginatedConcluidos" :key="item.id">
                                            <td>
                                                <a :href="`/web/digitalizar/ver/${item.evento_id}/${item.laborante_id}`" target="_blank" class="text-primary">
                                                    {{ item.evento ? item.evento.codigo : item.evento_id }}
                                                </a>
                                                <div style="font-size: 0.78rem; color: #8a8f98;">RBD: {{ item.evento?.rbd_colegio || '-' }}</div>
                                            </td>
                                            <td :title="item.evento ? item.evento.colegio : ''">
                                                {{ item.evento ? textoAcotado(item.evento.colegio, 22) : '-' }}
                                            </td>
                                            <td style="white-space:nowrap;">
                                                {{ item.evento ? (item.evento.fecha_inicio || '').substring(0,10) : '-' }}
                                            </td>
                                            <td :title="item.evento ? obtenerNombreCoordinador(item.evento.coordinador_evento, item.evento) : ''">
                                                {{ item.evento ? nombreCortoConPuntos(obtenerNombreCoordinador(item.evento.coordinador_evento, item.evento)) : '-' }}
                                            </td>
                                            <td :title="item.laborante ? item.laborante.name : ''">
                                                {{ item.laborante ? nombreCortoConPuntos(item.laborante.name) : '-' }}
                                            </td>
                                            <td style="text-align:center;">{{ item.fichas_totales ?? 0 }}</td>
                                            <td style="text-align:center;">
                                                <span class="text-success font-weight-bold">{{ item.fichas_revisadas ?? 0 }}</span>
                                            </td>
                                            <td style="text-align:center;">
                                                <span :class="(item.fichas_pagables ?? 0) > 0 ? 'text-primary font-weight-bold' : 'text-muted'">{{ item.fichas_pagables ?? 0 }}</span>
                                            </td>
                                            <td style="text-align:center;">
                                                <span class="text-danger">{{ item.fichas_descartadas ?? 0 }}</span>
                                            </td>
                                            <td style="text-align:center;">
                                                <span :class="(item.crm_exitosos ?? 0) > 0 ? 'text-success font-weight-bold' : 'text-muted'">{{ item.crm_exitosos ?? 0 }}</span>
                                            </td>
                                            <td style="text-align:center;">
                                                <span :class="(item.crm_duplicados ?? 0) > 0 ? 'text-warning font-weight-bold' : 'text-muted'">{{ item.crm_duplicados ?? 0 }}</span>
                                            </td>
                                            <td>
                                                <b-badge :variant="item.estado === 'Pagado' ? 'success' : item.estado === 'Creado' ? 'warning' : 'secondary'">
                                                    {{ item.estado || '-' }}
                                                </b-badge>
                                            </td>
                                        </tr>
                                        <tr v-if="paginatedConcluidos.length === 0">
                                            <td colspan="12" class="text-center text-muted">Sin registros</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div class="row mt-2">
                                <div class="col">
                                    <b-pagination
                                        v-model="currentPageConcluidos"
                                        :total-rows="rowsConcluidos"
                                        :per-page="perPageConcluidos"
                                        class="float-right mb-0"
                                    ></b-pagination>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- ===== FIN CONCLUIDOS ===== -->

        </div>
    </Layout>
</template>
<style scoped>
/* Indicador de fila en actualización (post-upload / post-transferencia) */
.row-refreshing > td {
    position: relative;
    background: repeating-linear-gradient(
        45deg,
        rgba(255, 193, 7, 0.08) 0,
        rgba(255, 193, 7, 0.08) 10px,
        rgba(255, 193, 7, 0.18) 10px,
        rgba(255, 193, 7, 0.18) 20px
    );
    background-size: 200% 200%;
    animation: row-refreshing-stripes 1.2s linear infinite;
}
.row-refreshing > td:first-child::before {
    content: 'Actualizando...';
    position: absolute;
    top: 4px;
    left: 8px;
    font-size: 0.7rem;
    font-weight: 600;
    color: #856404;
    background: #fff3cd;
    border: 1px solid #ffeeba;
    border-radius: 6px;
    padding: 1px 6px;
    z-index: 2;
    pointer-events: none;
}
.row-refreshing {
    pointer-events: none;
    opacity: 0.85;
}
@keyframes row-refreshing-stripes {
    0%   { background-position: 0 0; }
    100% { background-position: 40px 0; }
}

.rdf-column {
    white-space: nowrap;
    font-size: 0.9rem;
    letter-spacing: -0.02em;
}

.rdf-value {
    display: inline-block;
    min-width: 56px;
    text-align: center;
}

.rdf-help {
    cursor: pointer;
    font-size: 0.95rem;
}

.laborante-column {
    white-space: normal;
    min-width: 130px;
    max-width: 150px;
}

.laborante-name {
    font-weight: 600;
    line-height: 1.2;
    word-break: break-word;
}

.laborante-rut {
    margin-top: 0.2rem;
    font-size: 0.85rem;
    color: #6c757d;
    line-height: 1.15;
    word-break: break-word;
}

.crm-column {
    min-width: 150px;
    white-space: normal;
}

.crm-percent {
    font-weight: 600;
    line-height: 1.2;
}

.crm-detail {
    margin-top: 0.2rem;
    font-size: 0.78rem;
    color: #6c757d;
    line-height: 1.2;
}

.btn-accion {
    padding: 0.18rem 0.42rem !important;
    font-size: 0.72rem !important;
    line-height: 1.15 !important;
    white-space: nowrap;
}

.btn-accion i {
    font-size: 0.85rem !important;
    vertical-align: middle;
}

.action-buttons {
    display: flex;
    flex-direction: column;
    gap: 4px;
    align-items: flex-start;
}

.action-row {
    display: flex;
    flex-direction: row;
    gap: 4px;
    align-items: center;
}

.avance-column {
    min-width: 92px;
    max-width: 110px;
}
</style>
